__turbopack_context__.v({
  "LocIcon": "-PXPnG_LocIcon",
  "NoLocText": "-PXPnG_NoLocText",
  "NoLocation": "-PXPnG_NoLocation",
  "ThemeDk": "-PXPnG_ThemeDk",
});
